$shm_hitalama_components_tests_detail $mol_page
	definition $shm_hitalama_map_widget_entity_custom
	selected \
	minimal_width 480
	attr *
		^
		test_status <= status_kind \
	tools /
		<= Close $mol_link
			arg * application_test null
			sub / <= Close_icon $mol_icon_close
	body <= content_rows /
	Summary $mol_text
		text <= summary \
	Runs $mol_labeler
		title \История прогонов
		Content <= Run_select $mol_select
			value? <=> selected_run? \
			dictionary <= run_options *
	Run_pages $shm_paginator
		page? <=> run_page? 0
		total <= run_total 0
		page_size 20
	Result_status $mol_view
		sub / <= status_label \
	Report $mol_text
		text <= report \
	Empty $mol_view
		sub / \Результатов пока нет
